
export let HTTP_METHOD_GET = "GET";
export let HTTP_METHOD_POST = "POST";
export let HTTP_METHOD_PUT = "PUT";
export let HTTP_METHOD_DELETE = "DELETE";

export let HTTP_STATUS_CODE_UNAUTHORIZED = 401;

export let HTTP_HEADERS_JSON = { "Accept": "application/json", "Content-Type": "application/json" };

export let API_ENDPOINT_SEARCH = "/api/search";
export let API_ENDPOINT_DATA = "/api/search/data/facets";
export let API_ENDPOINT_BRANDS = "/api/search/brands";
export let API_ENDPOINT_MODELS = "/api/search/models";
export let API_ENDPOINT_SAVED_SEARCHES = "/api/search/saved";

export let API_ENDPOINT_NEW_VEHICLES_SEARCH = "/api/newvehicles/search";
export let API_ENDPOINT_NEW_VEHICLES_DATA = "/api/newvehicles/search/data";
export let API_ENDPOINT_NEW_VEHICLES_MODELS = "/api/newvehicles/search/models";
export let API_ENDPOINT_NEW_VEHICLES_SAVED_SEARCHES = "/api/newvehicles/search/saved";

export let API_ENDPOINT_LEADS = "/api/leads";
export let API_ENDPOINT_HOME = "/api/home";
export let API_ENDPOINT_VEHICLECATALOG = "/api/vehicle-catalog";
export let API_ENDPOINT_PROCUREMENT = "/api/procurement";
export let API_ENDPOINT_REFDATA = "/api/refdata";
export let API_ENDPOINT_USER = "/api/user";
export let API_ENDPOINT_USER_FAVORITE = "/api/user/favorite";
export let API_ENDPOINT_CARMATCH_NEW = "/api/carmatch/new";
export let API_ENDPOINT_CARMATCH_USED = "/api/carmatch/used";
export let API_ENDPOINT_LOCATIONS = "/api/locations";

export let SEARCH_PAGE_DEFAULT_SIZE = 12;
export let SEARCH_PAGE_DEFAULT_NUMBER = 1;
export let SEARCH_PAGE_DEFAULT_ORDER_BY = "";

export let LIST_ORDER_DIRECTION_ASC = "ASC";
export let LIST_ORDER_DIRECTION_DESC = "DESC";

export let NOTIFICATION_SUCCESS_MESSAGE_TIMEOUT = 1000;

export let VEHICLE_IMAGE_DEFAULT = "/static/images/autosapo-placeholder.png";

export let MESSAGE_DIRECTION_USER_TO_ADVERTISER = 0;
export let MESSAGE_LEAD_MESSAGE_STATUS_ACTIVE = 0;